import { createSelector } from '@reduxjs/toolkit';

const getFormTitles = (state) => state?.form?.formTitles;
const getFormTemplates = (state) => state?.form?.formTemplates;

// eslint-disable-next-line import/prefer-default-export
export const getKeyedFormTitles = createSelector(
  [getFormTitles],
  (formTitles) => formTitles?.reduce((accumulator, value) => ({ ...accumulator, [value]: { title: value } }), {}) || {},
);

export const getKeyedFormTemplates = createSelector(
  [getFormTemplates],
  (formTemplaes) => formTemplaes?.reduce((accumulator, value) => ({ ...accumulator, [value.formId]: { title: value.title } }), {}) || {},
);
